import { render, staticRenderFns } from "./FabricLowStock.vue?vue&type=template&id=1e7d7f60"
import script from "./FabricLowStock.vue?vue&type=script&lang=js"
export * from "./FabricLowStock.vue?vue&type=script&lang=js"
import style0 from "./FabricLowStock.vue?vue&type=style&index=0&id=1e7d7f60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports